module.exports = __webpack_public_path__ + "static/media/triporg--main.78c3315e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/triporg/triporg--main.jpg
// module id = 169
// module chunks = 0